module.exports = __webpack_public_path__ + "img/arrow-r-w.4a4b91b2.svg";